import {Component, OnInit} from '@angular/core';
import {RedirectHandlerService} from '@modules/public/redirect-handler/redirect-handler.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-redirect-handler',
    imports: [],
    providers: [RedirectHandlerService],
    templateUrl: './redirect-handler.component.html',
    styleUrl: './redirect-handler.component.scss'
})
export class RedirectHandlerComponent implements OnInit {

  private code: string;
  public isLoading = false;

  constructor(private aRoute: ActivatedRoute, private router: Router, private service: RedirectHandlerService) {
  }

  ngOnInit(): void {
    this.resolveCodeParam();
  }

  private resolveCodeParam(): void {

    this.isLoading = true;

    this.code = this.aRoute.snapshot.paramMap.get('code');

    if (!this.code) {
      this.redirectToError();
      return;
    }

    this.getUrlByCodeParam();
    this.isLoading = false;
  }

  private getUrlByCodeParam(): void {
    this.service.getRedirectUrl(this.code).then(
      (url: string) => {
        if (!url || url.trim() === '') {
          this.redirectToError();
          return;
        }
        this.redirectToUrl(url);
      },
      () => this.redirectToError()
    )
  }

  private redirectToUrl(url: string): void {
    window.location.href = url;
  }

  private redirectToError(): void {
    this.router.navigate(['/notfound']);
  }
}
